import React, { useEffect, useState } from 'react';
import './Intro.css';

// The machine typing its own name.
//
// The caret comes up alone on an empty sheet, the letters land one at a time
// with the caret pushed along in front of them, and then the whole thing
// fades into the page. It is short and it can be skipped: an intro you have
// to sit through twice is an intro you resent.

const WORD = 'ITYPE';
const LETTER_MS = 110;   // the pace of a confident typist
const HOLD_MS = 620;     // long enough to read the name

export default function Intro({ onDone }) {
  const [typed, setTyped] = useState(0);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const timers = [];
    // A beat of empty paper first, so the first letter is an event.
    for (let i = 1; i <= WORD.length; i += 1) {
      timers.push(setTimeout(() => setTyped(i), 260 + i * LETTER_MS));
    }
    timers.push(setTimeout(() => setLeaving(true), 260 + WORD.length * LETTER_MS + HOLD_MS));
    timers.push(setTimeout(onDone, 260 + WORD.length * LETTER_MS + HOLD_MS + 620));
    return () => timers.forEach(clearTimeout);
  }, [onDone]);

  useEffect(() => {
    const skip = () => { setLeaving(true); setTimeout(onDone, 240); };
    window.addEventListener('keydown', skip);
    window.addEventListener('pointerdown', skip);
    return () => {
      window.removeEventListener('keydown', skip);
      window.removeEventListener('pointerdown', skip);
    };
  }, [onDone]);

  return (
    <div className={`intro${leaving ? ' leaving' : ''}`} aria-label="ITYPE">
      <div className="intro-line">
        {WORD.split('').map((letter, i) => (
          <span
            key={`${letter}-${i}`}
            className={`intro-letter${i < typed ? ' struck' : ''}${i === 0 ? ' first' : ''}`}
          >
            {letter}
          </span>
        ))}
        <span className="intro-caret" style={{ left: `${typed}ch` }} />
      </div>
    </div>
  );
}
